import type {
  ProgramSlideImageBlockV1,
  ProgramSlideLayoutV1,
} from '../types/programContentSlideCanvas';

export type SlideBitmapImageKind = 'clipboardImage' | 'scanImage';
export type SlideImageBlockKind = 'image' | SlideBitmapImageKind;

export function isSlideBitmapImageKind(kind: string): kind is SlideBitmapImageKind {
  return kind === 'clipboardImage' || kind === 'scanImage';
}

export function bitmapImagesLayoutKey(kind: SlideBitmapImageKind): 'clipboardImages' | 'scanImages' {
  return kind === 'scanImage' ? 'scanImages' : 'clipboardImages';
}

export function getBitmapImages(
  layout: ProgramSlideLayoutV1,
  kind: SlideBitmapImageKind
): ProgramSlideImageBlockV1[] {
  return layout[bitmapImagesLayoutKey(kind)] ?? [];
}

export function findBitmapImage(
  layout: ProgramSlideLayoutV1,
  kind: SlideBitmapImageKind,
  id: string
): ProgramSlideImageBlockV1 | undefined {
  return getBitmapImages(layout, kind).find((img) => img.id === id);
}

export function resolveBitmapImageKindById(
  layout: ProgramSlideLayoutV1,
  id: string
): SlideBitmapImageKind | null {
  if ((layout.scanImages ?? []).some((img) => img.id === id)) return 'scanImage';
  if ((layout.clipboardImages ?? []).some((img) => img.id === id)) return 'clipboardImage';
  return null;
}

export function resolveSlideImageBlockKind(layout: ProgramSlideLayoutV1, id: string): SlideImageBlockKind {
  const bitmap = resolveBitmapImageKindById(layout, id);
  if (bitmap) return bitmap;
  return 'image';
}

export function forEachBitmapImage(
  layout: ProgramSlideLayoutV1,
  fn: (kind: SlideBitmapImageKind, img: ProgramSlideImageBlockV1) => void
): void {
  for (const img of layout.clipboardImages ?? []) fn('clipboardImage', img);
  for (const img of layout.scanImages ?? []) fn('scanImage', img);
}
